import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-gray-600">
            © {currentYear} Almajdouie Motors. All rights reserved.
          </div>

          <div className="flex items-center space-x-6 rtl:space-x-reverse text-sm text-gray-600">
            <a href="#" className="hover:text-primary-600 transition-colors">
              {t('common.documentation')}
            </a>
            <a href="#" className="hover:text-primary-600 transition-colors">
              Support
            </a>
            <a href="#" className="hover:text-primary-600 transition-colors">
              Version 1.0.0
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
